//#region Libraries
import styled from "styled-components";
//#endregion

export const Container = styled.section`
    display: flex;
    flex-direction: column;
    gap: 10px;
`;
export const ContentLocationPlaceStep1 = styled.section`
    & h5 + * > *:not(span) {
        width: 260px;
    }
`;
export const Title = styled.h3`
    font-size: 16px;
    font-weight: 700;
    color: var(--light-gray-5);
    margin: 0;
`;